import React from 'react';
import { DiscoverEventCardProps } from './types';

import loadable from '@loadable/component';
import {
    BrowseCardHierarchyExperimentValues,
    SearchCardFullClickExperimentValues,
} from '../../types';

//To prevent content flash during loadable fetch of module, importing
//all four directly to test the stableID enrollment approach.
import DiscoverHorizontalEventCard from './Horizontal/DiscoverHorizontalEventCard';
import DiscoverVerticalSearchEventCard from './Vertical/DiscoverVerticalSearchEventCard';

type EventCardMobileImportMap = Record<
    'control',
    React.FunctionComponent<DiscoverEventCardProps>
>;

type EventCardDesktopImportMap = Record<
    'control',
    React.FunctionComponent<DiscoverEventCardProps>
>;

type BrowseCardDesktopImportMap = Record<
    BrowseCardHierarchyExperimentValues,
    React.FunctionComponent<DiscoverEventCardProps>
>;

export const EXPERIMENT_SEARCH_CARD_MAP_MOBILE: EventCardMobileImportMap = {
    [SearchCardFullClickExperimentValues.control]:
        DiscoverVerticalSearchEventCard,
};

export const EXPERIMENT_SEARCH_CARD_MAP_DESKTOP: EventCardDesktopImportMap = {
    [SearchCardFullClickExperimentValues.control]: DiscoverHorizontalEventCard,
};

export const EXPERIMENT_BROWSE_CARD_MAP_DESKTOP: BrowseCardDesktopImportMap = {
    [BrowseCardHierarchyExperimentValues.control]: loadable(
        () => import('./Vertical/DiscoverVerticalBrowseEventCard'),
    ),
    [BrowseCardHierarchyExperimentValues.hierarchy]: loadable(
        () => import('./Vertical/DiscoverVerticalBrowseHierarchyEventCard'),
    ),
};

export type { DiscoverEventCardProps };
